import React from "react"
import types from "prop-types"
import clsx from "clsx"

const CircularIconButton = ({
  ariaLabel, className = "", icon, onClick,
}) => (
  <button
    className={clsx(
      className,
      "circular-icon-button",
    )}
    onClick={onClick}
    type="button"
    aria-label={ariaLabel}
  >
    <svg>
      <use xlinkHref={`#${icon}`} />
    </svg>
  </button>
)

CircularIconButton.propTypes = {
  ariaLabel: types.string.isRequired,
  className: types.string,
  icon: types.string.isRequired,
  onClick: types.func.isRequired,
}

export default CircularIconButton
